import { createContext, useContext, useEffect, useState } from "react";
import apiClient, { formatApiErrorDetail } from "@/lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("agroterra_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    apiClient
      .get("/auth/me")
      .then((res) => { setUser(res.data); localStorage.setItem("agroterra_user", JSON.stringify(res.data)); })
      .catch((e) => {
        const cached = localStorage.getItem("agroterra_user");
        if (!e.response && cached) {
          setUser(JSON.parse(cached));
          return;
        }
        localStorage.removeItem("agroterra_token");
        localStorage.removeItem("agroterra_user");
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleAuth = (data) => {
    localStorage.setItem("agroterra_token", data.token);
    localStorage.setItem("agroterra_user", JSON.stringify(data.user));
    setUser(data.user);
  };

  const login = async (email, password) => {
    try {
      const res = await apiClient.post("/auth/login", { email, password });
      handleAuth(res.data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const register = async (payload) => {
    try {
      const res = await apiClient.post("/auth/register", payload);
      handleAuth(res.data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    localStorage.removeItem("agroterra_token");
    localStorage.removeItem("agroterra_user");
    setUser(false);
  };

  const updateLanguage = async (language) => {
    setUser((u) => (u ? { ...u, language } : u));
    try {
      await apiClient.patch("/auth/preferences", { language });
    } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateLanguage }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
